const blogs = [
    {
        id: 1,
        title: "5 Tips for Engaging Lapsed Volunteers",
        description: "There are several effective steps that an organization can take to engage and drive value from lapsed volunteers",
        date: "October 11,2021",
        type: "Nature",
        img: "https://cdn.www.volunteerhub.com/vhmarketing2017/2020/02/Why-Volunteer-Management-is-Important-2021.png"
    }
]
export default blogs;